import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-typeahead/css/Typeahead.css";

import {
  Container,
  Row,
  Col,
  Table,
  ListGroup,
  Badge,
  Button,
} from "react-bootstrap";
import { useTable, useExpanded } from "react-table";

import { useDispatch, useSelector } from "react-redux";
import TimelinePicker from "../../../containers/TimeLinePicker/TimeLinePicker";
// import { useHistory } from 'react-router-dom';
// import styles from "./Dashboard.module.css";
import { newAlert } from "../../../Slices/alertSlice";
import { getDashboardByTimePeriod } from "../../../Slices/supervisorSlice";
import { formatDuration, calculateDateRange } from "./../../../helpers/stubs";
import { showModal, selectCandidate } from "../../../Slices/sessionSlice";
import moment from "moment";
import Loading from "../../../components/Loading/Loading";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const { dashboard, loading } = useSelector((state) => state.supervisorSlice);
  const {
    fromDate,
    toDate,
    sessionUser: { timezone },
  } = useSelector((state) => state.sessionSlice);
  //   const clientId = "61dbf3b281b7744240053d7f";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    // Use timezone-aware date calculation instead of UTC
    const { from, to } = calculateDateRange("this week", timezone);
    const fromDate = from.toISOString();
    const toDate = to.toISOString();
    dispatch(getDashboardByTimePeriod({ fromDate, toDate, timezone }));
  }, [timezone]);

  useEffect(() => {
    console.log("fromDate,toDate changed", fromDate, toDate);
    if (fromDate && toDate) {
      dispatch(
        getDashboardByTimePeriod({
          fromDate: fromDate,
          toDate: toDate,
          timezone,
        })
      );
    }
  }, [dispatch, fromDate, toDate, timezone]);

  const data = React.useMemo(() => {
    return dashboard.map((dashboardData, index) => {
      const {
        hourlyRate,
        activityPercentage,
        totalDuration,
        offline,
        tracker,
        candidateFirstName,
        candidateLastName,
        organization,
        project,
        candidateId,
        position,
        userId,
      } = dashboardData;
      console.log("dashboardData :- ", dashboardData);
      return {
        organizationName: (
          <p className="align-middle text-center">{organization}</p>
        ),
        projectName: <p className="align-middle text-center">{project}</p>,
        tracker: (
          <p className="align-middle text-center">
            {formatDuration(Math.ceil(tracker))}
          </p>
        ),
        offline: (
          <p className="align-middle text-center">{formatDuration(offline)}</p>
        ),
        position: (
          <>
            <p className="align-middle text-center">{position}</p>
          </>
        ),
        totalDuration: (() => {
          const candidateName = `${candidateFirstName} ${candidateLastName}`;
          return (
            <>
              <div className="text-center">
                <p className="">
                  {formatDuration(Math.ceil(totalDuration))}{" "}
                  <Badge
                    pill
                    bg="secondary"
                    onClick={() => {
                      dispatch(
                        selectCandidate({
                          userId,
                          candidateId,
                          candidateName: `${candidateFirstName} ${candidateLastName}`,
                        })
                      );
                      window.open(`/candidateScreenshots?candidateId=${candidateId}&&name=${candidateName.replace(/\s/g, "")}`, '_blank');
                    }}
                    style={{ fontSize: "10px", cursor: "pointer" }}
                  >
                    screenshots
                  </Badge>
                </p>
              </div>
            </>
          );
        })(),
        activity: <p className="text-center">{`${activityPercentage > 95 ? 95 : activityPercentage} %`}</p>,
        hourlyRate: (
          <p className="align-middle text-center">{`$ ${hourlyRate}`}</p>
        ),
        candidateName: (
          <>
            <span
              className="mr-4"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(
                  selectCandidate({
                    userId,
                    candidateId,
                    candidateName: `${candidateFirstName} ${candidateLastName}`,
                  })
                );
                navigate(`/candidateScreenshots`, { replace: true });
              }}
            >
              {`${candidateFirstName} ${candidateLastName}      `}
            </span>
          </>
        ),
      };
    });
  }, [dashboard]);
  const columns = React.useMemo(
    () => [
      {
        Header: "Organization",
        accessor: "organizationName", // accessor is the "key" in the data
        width: 50,
      },
      {
        Header: "Project",
        accessor: "projectName", // accessor is the "key" in the data
        width: 50,
      },
      {
        Header: "Candidate",
        accessor: "candidateName",
        width: 90,
      },
      {
        Header: "Position",
        accessor: "position",
        width: 10,
      },
      {
        Header: "Hours Tracked by Tracker",
        accessor: "tracker",
        width: 5,
      },
      {
        Header: "Hours NOT Tracked by Tracker",
        accessor: "offline",
        width: 5,
      },
      {
        Header: "Total Hours Spent",
        accessor: "totalDuration", // accessor is the "key" in the data
        width: 10,
      },
      {
        Header: "Activity",
        accessor: "activity",
        width: 5,
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useExpanded);

  return (
    <>
      <Container fluid={"lg"}>
        <Row className={"my-4 shadow-sm p-3 mb-5 bg-body rounded"}>
          <TimelinePicker />
        </Row>
      </Container>
      {loading ? (
        <Loading />
      ) : (
        <Row className={"my-4 shadow-sm p-3 mb-5 bg-body rounded text-center"}>
          <Table {...getTableProps()} bordered responsive>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: {
                          minWidth: column.minWidth,
                          width: column.width,
                        },
                      })}
                    >
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Row>
      )}
    </>
  );
}

export default Dashboard;
